import { Component, OnInit } from '@angular/core';
import { NavController, NavParams, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-cargar-medicos',
  templateUrl: './cargar-medicos.page.html',
  styleUrls: ['./cargar-medicos.page.scss'],
})
export class CargarMedicosPage implements OnInit {
  public _parent;
	public _medicosArray;
  public _medicosArrayTemp;
  
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public modalController: ModalController) {
    this._parent = navParams.get('_parent');
     	this._medicosArray = navParams.get('_medicosArray');
     	this._medicosArrayTemp = navParams.get('_medicosArray');
   }

  ngOnInit() {
  }

  seleccionarMedico(Codigo,Nombre,FechaMasCercana){
    //console.log(Codigo+' -- '+Nombre+' -- '+FechaMasCercana);
    //return false;
		this._parent.setMedico(Codigo,Nombre,FechaMasCercana)
    this.modalController.dismiss();
    //this.navCtrl.pop();
	}

	initializeItems() {
	    this._medicosArray = this._medicosArrayTemp;
	}

	getItems(ev: any) {
	    this.initializeItems();
	    const val = ev.target.value;
	    if (val && val.trim() != '') {
	      this._medicosArray = this._medicosArray.filter((item) => {
	        return (item.Nombre.toLowerCase().indexOf(val.toLowerCase()) > -1);
	      })
	    }
	}

	closeModal(){
    this.modalController.dismiss();
  }

}
